import type Keycloak from './Keycloak'

const getKeycloakConfig = async (): Promise<Keycloak> => {
  const url =
    process.env.REACT_APP_KEYCLOAK_URL != null
      ? `${process.env.REACT_APP_KEYCLOAK_URL}`
      : '/'

  console.log(process.env.REACT_APP_KEYCLOAK_URL)

  return {
    url: url,
    realm: 'f2821944-04c1-4750-bb4e-0d7cc80a5288',
    clientId: 'config-client',
  }
}

export default getKeycloakConfig
